<template>
  <!-- 主体为swiper标签 -->
  <!--属性 :options 绑定的是data中设置的swiper配置项-->
  <!--属性 ref 用于获取该dom元素，在计算属性computed中将被调用-->
  <!--属性 id 为swiper最外层容器设置css样式-->
  <swiper :options="swiperOption" ref="mySwiper" id="mySwiper" class="swiper-container">
    <!--必须的组件-->
    <!--每页幻灯片使用swiper-slide标签-->
    <!--幻灯片组件生成的标签自带.swiper-slide的类名，但单类名选择器设置的部分css(如宽高)将被覆盖-->
    <swiper-slide class="swiper_slide_item swiper-wrapper">
      <div class="swiper-slide">
        <h1>Slide 1</h1>
      </div>
    </swiper-slide>
    <swiper-slide class="swiper_slide_item swiper-wrapper">
      <div class="swiper-slide">
        <h1>Slide 2</h1>
      </div>
    </swiper-slide>
    <swiper-slide class="swiper_slide_item swiper-wrapper">
      <div class="swiper-slide">
        <h1>Slide 3</h1>
      </div>
    </swiper-slide>

    <!-- 可选的控件 -->
    <!--分页器-->
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>

</template>
<script>
import { swiperAnimateCache, swiperAnimate } from '@/utils/animate'

export default {
  data() {
    return {
      activeIndex: 2, // 当前页index

      // swiper 配置
      swiperOption: {
        direction: 'vertical', // swiper 方向
        mousewheel: true,
        // loop: true,


        // 分页器
        pagination: {
          el: '.swiper-pagination', //分页器的类名
          clickable: true // 点击分页器跳切换到相应的幻灯片
        },
        on: {
          // 初始化
          init: () => {
            // Swiper初始化，需要放在$nextTick()中，否则可能会获取不到元素
            this.$nextTick(() => {
              const mySwiper = this.$refs.mySwiper.$swiper

              //隐藏动画元素
              swiperAnimateCache(mySwiper)

              //初始化完成开始动画
              swiperAnimate(mySwiper)
            })
          },

          // 翻页
          slideChange: () => {
            // 记录当前页index
            this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex
          },

          slideChangeTransitionStart: () => {
            //每个slide切换结束时也运行当前slide动画
            swiperAnimate(this.$refs.mySwiper.$swiper)
          }
        }
      }
    }
  },
}
</script>
<style>
html,
body {
  margin: 0;
  padding: 0;
}

.swiper-container,
.swiper-wrapper,
.swiper-slide {
  height: 100vh;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: white;
}
</style>

